import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWebhooksQuery } from '~/queries/webhooks/useWebhooksQuery';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectWebhookId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: webhooks = [], isLoading } = useWebhooksQuery();

  const items = useMemo(
    () =>
      webhooks.map((webhook) => ({
        label: webhook.name || webhook.endpoint || webhook.id,
        value: webhook.id,
      })),
    [webhooks],
  );

  return (
    <ApiHelperSelectInput
      label={t('webhooks.choose')}
      items={items}
      onChange={(value) => setValue('webhook_id', value)}
      loading={isLoading}
      value={value}
      {...props}
    />
  );
};
